<template>
  <div class="cursor-pointer">
    <div v-for="(menu, i) in dataMenu.filter(m => m.isShow)" :key="i">
      <div @click="activeMenu(menu)" class="flex algin-center mb-10">
        <div style="width:31px;">
          <img :src="menu.icons" alt="" />
        </div>
        <div class="w-100">
          <div class="flex algin-center mb-10  justify-content-between">
            <span class="fw-400 c-caption">{{ menu.label }}</span>
            <div v-if="menu.isChill">
              <img v-if="!menu.isOpenChild" :src="bg.icon_drop_right" alt="" />
              <img v-if="menu.isOpenChild" :src="bg.icon_drop_down" alt="" />
            </div>
          </div>
          <div class="hr-menu"></div>
        </div>
      </div>
      <div v-if="menu.isChill && openChildren[menu.key]">
        <div
          style="margin-left: 30px;"
          class="mb-10"
          v-for="item in menu.child"
          :key="item.label"
          @click="onActiveChild(item, menu)"
        >
          <div class="w-100">
            <div class="flex align-center mb-10 justify-content-between">
              <span class="fw-400 c-tiny">{{ item.label }}</span>
              <img :src="bg.icon_drop_right" alt="" />
            </div>
            <div class="hr-menu"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex algin-center">
      <div style="width:31px;">
        <img :src="icons.LangIcon" alt="" />
      </div>
      <div class="w-100">
        <div class="flex algin-center mb-10  justify-content-between">
          <span class="fw-400 c-caption">{{ $t("wap.text57") }}</span>
          <!-- <div>
            <img class="mr-20" :src="icons.VIIcon" alt="" />
            <span class="fw-400 c-caption">Tiếng việt</span>
          </div> -->

          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <flag :iso="locale || 'vn'" v-bind:squared="false" />
              <span class="text-lang c-text-main c-medium-text c-medium-text">{{
                locale || "vn"
              }}</span>
              <i class="el-icon-arrow-down el-icon--right c-black-text"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="lang in languages"
                :key="lang.title"
                :value="lang.language"
                :command="lang.language"
              >
                <flag :iso="lang.flag" v-bind:squared="false" />
                <span class="text-lang-item c-text-main">{{
                  lang.flag
                }}</span></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="hr-menu"></div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import {
  decodeToken,
  getBackGround,
  setFlag,
  setLanguage,
  getToken
} from "@/utils/wapAuth";
import ArrowRightIcon from "@/assets/img/iconV2/arrow-right.svg";
import downIcon from "@/assets/img/iconV2/downIcon.svg";
import rightIcon from "@/assets/img/iconV2/rightIcon.svg";

import OrderIcon from "@/assets/img/iconV2/order_icon.svg";
import { getInfo } from "@/utils/auth";
import LangIcon from "@/assets/img/iconV2/lang_menu.svg";
import OrderMenuIcon from "@/assets/img/iconV2/order_menu.svg";
import PolicyMenuIcon from "@/assets/img/iconV2/policy_menu.svg";
import RulesMenuIcon from "@/assets/img/iconV2/rules.svg";
import PhoneMenuIcon from "@/assets/img/iconV2/phone_menu.svg";
import UserMenuIcon from "@/assets/img/iconV2/user_login.svg";
import VIIcon from "@/assets/img/iconV2/VIIcon.svg";
import { LIST_POLICY, LIST_PROD_BANK, SOURCE_BANK } from "@/constant/contant";

export default {
  components: {},
  bodyClass: "menu-profile-page",
  props: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  data() {
    return {
      bg: getBackGround(),
      icons: {
        rightIcon,
        downIcon,
        ArrowRightIcon,
        OrderIcon,
        LangIcon,
        OrderMenuIcon,
        RulesMenuIcon,
        PolicyMenuIcon,
        PhoneMenuIcon,
        UserMenuIcon,
        VIIcon
      },
      images: {
        DefaultAvatar:
          "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      },
      languages: [
        { flag: "vn", language: "vi", title: "Tiếng Việt" },
        { flag: "us", language: "en", title: "English" },
        { flag: "kr", language: "kr", title: "한국어" },
        { flag: "jp", language: "jp", title: "日本語" }
      ],
      locale: localStorage.getItem("flag"),
      openChildren: {}
    };
  },
  computed: {
    dataMenu() {
      return [
        {
          key: "login",
          label: this.$t("wap.text109"),
          icons: UserMenuIcon,
          isChill: false,
          isShow: !getInfo()
        },
        // {
        //   key: "prod",
        //   label: this.$t("wap.text110"),
        //   icons: OrderMenuIcon,
        //   isChill: true,
        //   child: LIST_PROD_BANK,
        //   isShow: true
        // },
        // {
        //   key: "rules",
        //   label: this.$t("wap.text114"),
        //   icons: RulesMenuIcon,
        //   isChill: false,
        //   isShow: true
        // },
        {
          key: "prod",
          label: this.$t("wap.text110"),
          icons: OrderMenuIcon,
          isChill: true,
          child: [
            {
              label: this.$t("wap.text111"),
              key: "service-nab",
              link:
                "https://www.namabank.com.vn/Data/Sites/1/media/the/2023/Golf/DKDK%20CHI%20TIET%20CHUONG%20TRINH%20UU%20DAI%20DAC%20QUYEN%20THE%20TIN%20D%E1%BB%A4NG%20HAPPY%20GOLF%2012.07.2023.pdf"
            },
            {
              label: this.$t("wap.text112"),
              key: "service-stb",
              link:
                "https://www.sacombank.com.vn/content/dam/sacombank/files/ca-nhan/the/tin-dung/Sacombank_DKDKSuDungUuDaiGolf.pdf"
            },
            {
              label: this.$t("wap.text113"),
              key: "service-tech",
              link:
                "https://techcombank.com/content/dam/techcombank/public-site/documents/the-le-chi-tiet-golf-private-26072024.pdf"
            }
          ],
          isShow: getToken().bank_id != SOURCE_BANK.BIDV
        },
        {
          key: "rules",
          label: this.$t("wap.text114"),
          icons: RulesMenuIcon,
          isChill: true,
          child: LIST_POLICY,
          isShow: true
        },
        {
          key: "policy",
          label: this.$t("wap.text115"),
          icons: PolicyMenuIcon,
          isChill: false,
          isShow: true
        },
        {
          key: "bang-gia",
          label: this.$t("wap.text150"),
          icons: RulesMenuIcon,
          isChill: false,
          isShow: true
        },
        {
          key: "contact",
          label: this.$t("wap.text116"),
          icons: PhoneMenuIcon,
          isChill: false,
          isShow: true
        }
      ];
    }
  },
  watch: {},
  methods: {
    decodeToken,

    activeMenu(menu) {
      if (menu.isChill) {
        // Thay đổi trạng thái của menu cụ thể trong openChildren
        this.$set(this.openChildren, menu.key, !this.openChildren[menu.key]);
        return;
      }
      if (["login", "prod", "rules", "bang-gia"].includes(menu.key)) {
        this.handleCloseProfile();
      }
      switch (menu.key) {
        case "login":
          this.$store.dispatch("showLoginDialog");
          break;
        case "contact":
          window.location.href = "tel:02471001088";
          break;
        case "logout":
          this.handleLogout();
          break;
        case "rules":
          this.$router.push("/policy/cancellation");
          break;
        case "bang-gia":
          this.$router.push("/bang-gia");
          break;
        case "policy":
          window.open(
            "https://hio.wghn.net/terms-of-service/loyalty-membership-policy",
            "_blank"
          );
          break;
        default:
          this.getRedirectRoute(menu);
          break;
      }
    },
    getRedirectRoute(menu) {
      this.handleCloseProfile();
      this.$router.push({
        path: "/wap/redirect-other-service",
        query: {
          title: menu.label,
          type: menu.key
        }
      });
    },
    onActiveChild(item, menu) {
      if (menu.key == "list_policy") {
        window.open(item.link, "_blank");
        return;
      }
      if (menu.key == "rules") {
        this.handleCloseProfile();
        this.$router.push(item.link);
        return;
      }
      this.getRedirectRoute(item);
    },
    handleCloseProfile() {
      setTimeout(() => {
        this.$store.dispatch("setShowMenuApp", false);
      }, 150);
    },
    handleLogout() {
      this.$store.dispatch("disconnectChat");
      window.localStorage.clear("info");
      window.location.reload();
    },
    handleCommand(command) {
      // console.log("Command received:", command);

      i18n.locale = command;
      setLanguage(command);

      switch (command) {
        case "en":
          this.locale = "us";
          setFlag("us");
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to: us");
          break;
        case "vi":
          this.locale = "vn";
          setFlag("vn");
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to: vn");
          break;
        case "kr":
          this.locale = "kr";
          setFlag("kr");
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to: kr");
          break;
        case "jp":
          this.locale = "jp";
          setFlag("jp");
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to: jp");
          break;
        default:
          this.locale = command;
          setFlag(command);
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to:", command);
          break;
      }
    }
  }
};
</script>
<style lang="scss"></style>

<style scoped>
.text-lang {
  padding-left: 4px;
  font-weight: 500;
  text-transform: uppercase;
}
.text-lang-item {
  padding-left: 4px;
  text-transform: uppercase;
}
.my-15 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.hr-menu {
  background-color: rgba(219, 219, 219, 1);
  height: 1px;
  width: 100%;
}
.divider-view {
  height: 10px !important;
  width: 100%;
  background-color: #e3e3e3;
  margin: 30px 0;
}

.top-spacing {
  padding-top: 100px;
}

.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}

// .text-lang {
//     color: hsla(219, 75%, 35%, 1) !important;
//     padding-left: 4px;
//     font-weight: 500;
//     text-transform: uppercase;
// }
</style>
